export default "__VITE_ASSET__BOpRSaOY__";